import { apiClient } from './client';
import type { ApiResponse } from '../types/api';
import type {
  Strategy,
  CreateStrategyRequest,
  UpdateStrategyRequest,
  StrategyStats,
  StrategyListResponse,
} from '../types/strategy';

export interface GetStrategiesParams {
  page?: number;
  limit?: number;
  is_active?: boolean;
}

export const strategyApi = {
  // 获取策略列表
  getStrategies: (params?: GetStrategiesParams): Promise<ApiResponse<StrategyListResponse>> =>
    apiClient.get('/strategies', { params }),

  // 获取策略详情
  getStrategyById: (id: number): Promise<ApiResponse<Strategy>> =>
    apiClient.get(`/strategies/${id}`),

  // 创建策略
  createStrategy: (data: CreateStrategyRequest): Promise<ApiResponse<Strategy>> =>
    apiClient.post('/strategies', data),

  // 更新策略
  updateStrategy: (id: number, data: UpdateStrategyRequest): Promise<ApiResponse<Strategy>> =>
    apiClient.put(`/strategies/${id}`, data),

  // 删除策略
  deleteStrategy: (id: number): Promise<ApiResponse<void>> =>
    apiClient.delete(`/strategies/${id}`),

  // 获取策略统计
  getStrategyStats: (id: number): Promise<ApiResponse<StrategyStats>> =>
    apiClient.get(`/strategies/${id}/stats`),
};
